<template>
  <!-- equipmentSec start -->
  <div class="flex flex-col gap-2 tablet:gap-0">
    <div class="flex flex-wrap tablet:flex-nowrap items-center justify-between">
      <div class="flex items-start tablet:items-center gap-2">
        <span class="w-2 h-2 rounded-full bg-[#FE5000] mt-1.5 tablet:mt-0"></span>
        <span class="w-10 h-2 rounded-full bg-[#FE5000] mt-1.5 tablet:mt-0"></span>
        <h2 class="m-0 font-lato font-[700] text-[18px] laptop:text-[20px] text-[#092E87]">Enter or update the equipment
          information</h2>
      </div>
       <button
        class="group cursor-pointer w-[30px] laptop:w-[40px] h-[30px] laptop:h-[40px] ml-auto disabled:bg-[#EFEFEF] disabled:flex justify-center items-center rounded-full disabled:cursor-not-allowed"
        @click="resetClicked()" :disabled="!isFormChanged">
        <img src="../../assets/images/reset-form-icon.png" alt="Reset Icon"
          class="w-full h-full hidden laptop:block group-disabled:!hidden">
        <img src="../../assets/images/reset-icon.png" alt="Reset Icon"
          class="w-full h-full block laptop:hidden group-disabled:!hidden">
        <img src="../../assets/images/bx_reset.png" alt="Reset Icon"
          class="w-[24px] h-[24px] hidden group-disabled:block">
      </button>
    </div>
    <div class="grid grid-cols-1 tablet:grid-cols-2 gap-2 tablet:gap-4">
      <div class="flex flex-col gap-1">
        <label class="text-[16px] font-lato text-[#999]">System Type</label>
        <input v-model="formData.equipment_type" type="text" placeholder="Enter system type"
          class="form-control !rounded-[10px] focus:!border-[#ccc] placeholder:!text-[#b8b8b8]" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[16px] font-lato text-[#999]">Make</label>
        <input v-model="formData.equipment_make" type="text" placeholder="Enter make"
          class="form-control !rounded-[10px] focus:!border-[#ccc] placeholder:!text-[#b8b8b8]" @keyup="validateField">
      </div>
    </div>
    <div class="grid grid-cols-1 tablet:grid-cols-3 gap-2 tablet:gap-4">
      <div class="flex flex-col gap-1">
        <label class="text-[16px] font-lato text-[#999]">Model <span class="text-[#FE5000]">*</span></label>
        <input v-model="formData.equipment_model" type="text" placeholder="Enter model"
          class="form-control !rounded-[10px] focus:!border-[#ccc] placeholder:!text-[#b8b8b8]" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[16px] font-lato text-[#999]">Serial <span class="text-[#FE5000]">*</span></label>
        <input v-model="formData.equipment_serial" type="text"  placeholder="Enter serial" :disabled="serialDisable"
          class="form-control !rounded-[10px] focus:!border-[#ccc] placeholder:!text-[#b8b8b8]" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[16px] font-lato text-[#999]">Date of Manufacture </label>
        <date-picker v-model:value="formData.equipment_manufacture_date" input-class="disable-input !rounded-[10px]"
          format="MM/DD/YYYY" :placeholder="'Select Date'" :confirm="true" :readonly="false" :clearable="false"
          :disabled-date="disabledBefore" value-type="format" class="focus:!border-[#ccc]" @change="validateField">
            <template #icon-calendar>
              <img src="../../assets/images/calender-icon.svg" alt="calendar" class="w-5 h-5" />
            </template>
        </date-picker>
      </div>
    </div>
  </div>
  <div class="text-center mt-3">
    <button :disabled="txtSerialDisable"
      class="group w-max mx-auto mt-5 cursor-pointer flex justify-center items-center gap-2.5 px-[30px] py-2 rounded-full border-1 border-[#FE5000] mobile:bg-[#FE5000] mobile:text-[#fff] laptop:bg-[#fff] laptop:text-[#FE5000] hover:bg-[#FE5000] hover:text-[#fff] disabled:border-[#eee] disabled:bg-[#eee] disabled:text-[#ccc] disabled:cursor-not-allowed"
      @click="storeEquipmentInfoClicked()">
      {{ $route.query.is_edit == 1 ? "Continue" : "Continue Editing" }}
      <div v-if="$route.query.is_edit != 1">
        <img v-if="!txtSerialDisable" src="../../assets/images/edit-quote-button-icon.png" alt="Icon" class="w-[26px] h-[26px] hidden laptop:block laptop:group-hover:hidden">
        <img v-if="!txtSerialDisable" src="../../assets/images/edit-quote-button-hover-icon.png" alt="Icon" class="w-[26px] h-[26px] block laptop:hidden laptop:group-hover:block">
        <img src="../../assets/images/disabled-pencil.png" alt="Icon" class="w-[26px] h-[26px] hidden group-disabled:block group-disabled:grayscale filter">
      </div> 
    </button>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {
    DatePicker,
  },

  data() {
    return {
      txtSerialDisable: true,
      serialDisable: false,
      originalFormData: '',
      formData: {
        equipment_type: "",
        equipment_make: "",
        equipment_model: "",
        equipment_serial: "",
        equipment_manufacture_date: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "setEquipmentInfo",
      "saveEquipmentInfo",
      "quoteDetail",
      "saveEquipmentInfoStore",
    ]),

    isFormChanged() {
      return JSON.stringify(this.formData) !== this.originalFormData;
    }
  },

  watch: {
    saveEquipmentInfo: function () {
      this.setData();
    },

    saveEquipmentInfoStore: function () {
      toast.success("Equipment information updated successfully.");
      this.setCommponent("QuoteItems");
    },
  },

  setUp() { },
  mounted() {
    this.getEquipmentInfoDetail();
  },

  methods: {
    ...mapActions(["getEquipmentInfo", "equipmentInfoStore", "setCommponent"]),

    resetClicked() {
      this.setData();
    },

    validateField() {
      // alert("validate" , this.formData.equipment_manufacture_date)

      if (this.isValid("watcher")) {
        this.txtSerialDisable = false;
      } else {
        this.txtSerialDisable = true;
      }
    },

    disabledBefore: function (date) {
      const cdate = new Date();
      cdate.setHours(0, 0, 0, 0);
      return date > cdate;
    },
    setData() {
      let equipmentInfo = {
        equipment_type:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_type ?? "",
        equipment_make:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_make ?? "",
        equipment_model:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_model ?? "",
        equipment_serial:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_serial ?? "",
        equipment_manufacture_date:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_manufacture_date ?? "",
      };
      this.serialDisable =
        equipmentInfo.equipment_serial.length <= 0 ? false : true;
      this.formData = equipmentInfo;
      this.originalFormData = JSON.stringify(this.formData);
      this.validateField();
    },

    getEquipmentInfoDetail() {
      this.getEquipmentInfo({
        manual_quote_id: this.quoteDetail.id,
      });
    },

    storeEquipmentInfoClicked() {
      this.$dialog.show({
        title: "Equipment Information",
        text: "Are you sure you want to update equipment information?",
        // image: "pop-req-img.png",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          if (this.isValid("submit")) {
            this.formData["manual_quote_id"] = this.quoteDetail.id;
            this.equipmentInfoStore(this.formData);
          }
        },
      });
    },

    isValid(action) {
      let status = true;
      let message = "";

      if (this.formData.equipment_type.length <= 0) {
        status = false;
        message = "System Type field is required.";
      } else if (this.formData.equipment_make.length <= 0) {
        status = false;
        message = "Make field is required.";
      } else if (this.formData.equipment_model.length <= 0) {
        status = false;
        message = "Model field is required.";
      }
      // else if (this.formData.equipment_serial.length <= 0) {
      //     status = false
      //     message = 'Serial field is requierd.'
      // }
      else if (this.formData.equipment_manufacture_date.length <= 0) {
        status = false;
      }

      if (!status && action == "submit") {
        toast.error(message);
      }

      return status;
    },
  },
};
</script>
